import { render, staticRenderFns } from "./generate-docx-report-submit-modal.vue?vue&type=template&id=7b13f671&scoped=true"
import script from "./generate-docx-report-submit-modal.vue?vue&type=script&lang=js"
export * from "./generate-docx-report-submit-modal.vue?vue&type=script&lang=js"
import style0 from "./generate-docx-report-submit-modal.vue?vue&type=style&index=0&id=7b13f671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13f671",
  null
  
)

export default component.exports